import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { notificationsSettingsRouter, emailLogRouter } from './routing/notificationsRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'notifications',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'notifications-dashboard-tool',
  },
  routes,
  translations: {},
  lazyTranslations: {
    EN_US: () => import('./translations/en-US.json'),
    ES_ES: () => import('./translations/es-ES.json'),
  },
  routers: {
    partnerScoped: [notificationsSettingsRouter],
    scoped: [emailLogRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [],
}

export default definition
